import HomeContainer from 'components/Home/HomeContainer'
import HomePresentation from 'components/Home/HomePresentation'

export default {
  Container: HomeContainer,
  Presentation: HomePresentation,
}
